import { api } from '@setplex/tria-api'
import { attach, createEvent, createStore, sample } from 'effector'
import { features } from '~/core/flags'
import { aye, nay, noop, T } from '~/shared/helpers'
import { formatAppTheme } from './lib'
import { $appTheme } from './model'

export const init = createEvent()

const getAppearanceStylesFx = attach({
  effect: api.appearance.getAppearanceStylesFx,
})

export const $ready = createStore(false).reset(init)

// get appearance styles on init
sample({
  clock: init,
  source: features.$featuredFlags,
  filter: (features) => aye(features.appearanceCustomizationEnabled),
  target: getAppearanceStylesFx.prepend(noop),
})

sample({
  clock: init,
  source: features.$featuredFlags,
  filter: (features) => nay(features.appearanceCustomizationEnabled),
  fn: T,
  target: $ready,
})

// fill theme store if appearance styles are loaded
sample({
  clock: getAppearanceStylesFx.doneData,
  filter: aye,
  fn: (appearance) => formatAppTheme(appearance),
  target: $appTheme,
})

sample({
  clock: getAppearanceStylesFx.finally,
  fn: T,
  target: $ready,
})
